import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuperAdminMemberManagementComponent } from './super-admin-member-management.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiClient } from '../core/api-client.service';
import { SuperAdminChamberPerkManagementComponent } from './super-admin-chamber-perk-management.component';
import { SuperAdminChamberPerkDetailsComponent } from './super-admin-chamber-perk-details.component';
import { RouterModule } from '@angular/router';
import { AddEditChamberPerkModalComponent } from './add-edit-chamber-perk-modal.component';
import {  MbscModule } from '@mobiscroll/angular';
import { SuperAdminMemberDetailsComponent } from './super-admin-member-details.component';
import { AddEditMemberAddressModalComponent } from './modals/add-edit-address-modal.component';
import { EditCompanyInfoModalComponent } from './modals/edit-company-info-modal.component';
import { EditCompanyLiaisonComponent } from './modals/edit-company-liaison.component';
import { EditCompanyPaymentInfoModalComponent } from './modals/edit-company-payment-info-modal.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { EditCompanyDirectoryInfoModalComponent } from './modals/edit-company-directory-info-modal.component';
import { EditorModule } from '@tinymce/tinymce-angular';


@NgModule({
  declarations: [
    SuperAdminMemberManagementComponent,
    SuperAdminChamberPerkManagementComponent,
    SuperAdminChamberPerkDetailsComponent,
    AddEditChamberPerkModalComponent,
    SuperAdminMemberDetailsComponent,
    AddEditMemberAddressModalComponent,
    EditCompanyInfoModalComponent,
    EditCompanyLiaisonComponent,
    EditCompanyPaymentInfoModalComponent,
    EditCompanyDirectoryInfoModalComponent
  ],
  imports: [
    CommonModule
    , BrowserModule
    , FormsModule
    , ReactiveFormsModule
    , NgbPaginationModule
    , RouterModule
    , MbscModule
    , NgxMaskDirective
    , NgxMaskPipe
    , EditorModule
  ],
    providers: [ApiClient
        , provideNgxMask()    ],
})
export class SuperAdminMemberManagementModule { }
